
import LoginTabs from '@/components/Auth/Tabs';
import LoginTab from '@/components/Auth/LoginTab';
import SignupTab from '@/components/Auth/SignupTab';

export default {
  components: {
    LoginTabs,
    LoginTab,
    SignupTab
  },
  computed: {
    tabLabels() {
      return [this.$t('signup'),this.$t('signin')];
    },
    selectedIndex() {
      return this.$route.name === 'auth:signup' ? 0 : 1;
    }
  },
  methods: {
    tabSelected(index) {
      this.$router.push({ name: index === 1 ? 'auth:login' : 'auth:signup' });
    }
  }
};
